import { render, staticRenderFns } from "./BaseBtn.vue?vue&type=template&id=5aff0df6&scoped=true&"
import script from "./BaseBtn.vue?vue&type=script&lang=js&"
export * from "./BaseBtn.vue?vue&type=script&lang=js&"
import style0 from "./BaseBtn.vue?vue&type=style&index=0&id=5aff0df6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aff0df6",
  null
  
)

export default component.exports